import * as React from "react";
import { cva, type VariantProps } from "class-variance-authority";
import { cn } from "@/lib/cn";

/**
 * Badge — Volume 03 §8. Trạng thái ngắn theo màu semantic.
 * Tag mặc định trung tính; chỉ category quan trọng mới có màu.
 */
const badgeVariants = cva(
  "inline-flex items-center gap-1 rounded-full px-2.5 py-0.5 text-caption font-medium",
  {
    variants: {
      variant: {
        neutral: "bg-subtle text-foreground-secondary",
        primary: "bg-blue-50 text-primary dark:bg-primary/15",
        success: "bg-green-50 text-success dark:bg-success/15",
        warning: "bg-orange-50 text-warning dark:bg-warning/15",
        danger: "bg-red-50 text-danger dark:bg-danger/15",
        info: "bg-blue-50 text-info dark:bg-info/15",
        ai: "bg-purple-50 text-ai dark:bg-ai/15",
      },
    },
    defaultVariants: {
      variant: "neutral",
    },
  }
);

export interface BadgeProps
  extends React.HTMLAttributes<HTMLSpanElement>,
    VariantProps<typeof badgeVariants> {
  dot?: boolean;
}

export function Badge({ className, variant, dot, children, ...props }: BadgeProps) {
  return (
    <span className={cn(badgeVariants({ variant }), className)} {...props}>
      {dot && <span className="size-1.5 rounded-full bg-current" aria-hidden="true" />}
      {children}
    </span>
  );
}

export { badgeVariants };
